/**
 * CategoryRequestListContainer
 * --
 */
import React, { useEffect, useState } from 'react';
import CategoryRequestListPresenter from './CategoryRequestListPresenter';
import { useGetMenuCategories } from 'hooks/ProductCategoryHooks';
import { useGetStores } from 'hooks/ShopInformationHooks';
import { LoadingPage } from 'components';
import MessageAlert from 'utils';

const CategoryRequestListContainer = () => {
  /* ===== ROUTE ===== */
  /* ===== PROPS ===== */
  /* ===== Mutate ===== */

  /* ===== Data ===== */

  // 메뉴 카테고리 전체 조회
  const { data: Categories } = useGetMenuCategories();
  // 매장 전체 조회
  const { data: Store } = useGetStores();

  /* ===== STATE ===== */
  const [data, setData] = useState([]);
  const [categoryData, setCategoryData] = useState([]);
  // 모달 open 여부
  const [isOpened, setIsOpened] = useState(false);
  // 모달 타입
  const [modalType, setModalType] = useState('');
  const [modalData, setModalData] = React.useState({
    menu: {},
    category: {},
  });
  // 로딩
  const [isLoading, setIsLoading] = React.useState(false);
  // 메뉴 파일
  const [files, setFiles] = useState([]);

  //메뉴 선택 데이터
  /* ===== VARIABLE ===== */

  /* ===== FUNCTION ===== */
  /**
   * 모달 핸들러
   * --
   */
  const handleModal = (open, type = '', data = {}) => {
    setModalData((prev) => ({
      ...prev,
      [type]: data,
    }));
    setIsOpened(!open);
    setModalType(type);
  };

  /**
   * 데이터 바인딩 함수
   * --
   */
  const handleChange = (t, v, o) => {
    let newData = modalData[o];

    newData[t] = v;
    const d = {
      ...modalData,
      o: { ...newData },
    };

    setModalData(d);
  };

  const handleSubmit = async (t, s = 'UPDATE', menu_id, application_status) => {
    const type = t.toLocaleUpperCase();
    const submit = s.toLocaleUpperCase();

    const submitType = {
      MENU: '메뉴',
      UPDATE: '수정',
    };

    const submitFunc = {
      MENU: {
        // UPDATE: updateCategory,
      },
    };

    try {
      setIsLoading(true);

      let allSuccess = true;

      const { status } = await submitFunc[type][submit]({
        menu_id: menu_id,
        application_status: application_status,
      });

      if (status !== 200) {
        allSuccess = false;
      }

      if (allSuccess) {
        MessageAlert.success(
          `성공적으로 ${submitType[type]}이/가 ${submitType[submit]}되었습니다.`
        );
        setModalData((prev) => ({ ...prev, t: {} }));
        setIsOpened(false);
        window.location.reload();
      } else {
        MessageAlert.warning(
          `${submitType[type]}을/를 ${submitType[submit]}하는데 실패하였습니다.`
        );
      }
    } catch (err) {
      MessageAlert.error(
        `${submitType[type]}을/를 ${submitType[submit]}하는데 오류가 발생하였습니다.`
      );
      console.error(`[CREATE ${type}] ERROR : `, err);
      throw err;
    } finally {
      setTimeout(() => {
        setIsLoading(false);
      }, 500);
    }
  };

  /* ===== HOOKS ===== */
  useEffect(() => {
    const NewCategories = Categories?.data?.filter(
      (item) => item.application_status === 'APPROVE'
    );

    setCategoryData(NewCategories);
    setData(NewCategories);
  }, [Categories]);

  console.log(data);
  /* ===== RENDER ===== */
  return (
    <>
      {isLoading && (
        <LoadingPage text={'데이터를 처리중입니다. 잠시만 기다려주세요.'} />
      )}
      <CategoryRequestListPresenter
        data={data}
        categoryData={categoryData}
        isOpened={isOpened}
        modalData={modalData}
        modalType={modalType}
        files={files}
        onOpen={handleModal}
        onChange={handleChange}
        onSubmit={handleSubmit}
        onFileChange={setFiles}
      />
    </>
  );
};

export default CategoryRequestListContainer;
